itsoftApp.createModule("insertUtekaSlider", ["utekaInit"], function () {
    var module = this;
    var insertUtekaSlider = function () {
        var widget = document.querySelector(".js-uteka-widget-slider")
        if (widget) {
            window.uteka.loadWidgetPre(widget, {
                productIds: [
                    "372315",
                    "372314"
                ]
            })
        }
    };
    // insertUtekaSlider();
    module.callback = insertUtekaSlider
});